//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DpConfirmDialog',
  props: {
    title: { type: String, default: '' },
    type: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    visible: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      isVisible: false,
    };
  },
  computed: {
    displayTitle() {
      if (this.title) {
        return this.title;
      }

      switch (this.type) {
        case 'delete': return 'Confirm deletion';
        case 'confirm': return 'Confirm';
        default: return 'Confirm';
      }
    },
    buttonType() {
      switch (this.type) {
        case 'delete': return 'error';
        case 'confirm': return 'primary';
        default: return null;
      }
    },
    confirmButtonText() {
      switch (this.type) {
        case 'delete': return 'Delete';
        case 'confirm': return 'Confirm';
        default: return 'Nothing';
      }
    },
  },
  watch: {
    visible(v) {
      this.isVisible = v;
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    confirm() {
      this.$emit('confirm');
    },
    close() {
      this.cancel();
      this.$emit('update:visible', false);
    },
  },
};
